import React, { Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { PrivateRoute, ProtectedRouteProps } from './components/private-route';
import { Loading } from './components/ui/loading';
import NotFound from './pages/not-found';
import RecoveryPassword from './pages/recovery-password';

const FormSurfacado = React.lazy(() => import('./pages/surfacado/form'));
// const PageSurfacado = React.lazy(() => import('./pages/surfacado/list'));
const FormSurfacedEdit = React.lazy(() => import('./pages/surfacado/edit'));
const FormGrade = React.lazy(() => import('./pages/grade/edit'));
const FormGradeList = React.lazy(() => import('./pages/grade/edit-list'));
const FormOthers = React.lazy(() => import('./pages/outros-produtos/product'));
const PageGrade = React.lazy(() => import('./pages/grade/list'));
const PageCheckout = React.lazy(() => import('./pages/checkout'));
const PageCheckoutUnified = React.lazy(() => import('./pages/checkout-unified'));
const PageMyOrders = React.lazy(() => import('./pages/my-orders'));
const PageParapar = React.lazy(() => import('./pages/parapar/list'));
const FormParapar = React.lazy(() => import('./pages/parapar/form'));
const PageParaparEdit = React.lazy(() => import('./pages/parapar/edit'));
const Home = React.lazy(() => import('./pages/home'));
const HomeNew = React.lazy(() => import('./pages/home-new'));
const PageCart = React.lazy(() => import('./pages/cart'));
const PageAddress = React.lazy(() => import('./pages/address/list'));
const PageUserManagement = React.lazy(() => import('./pages/users/list'));
const PageWallet = React.lazy(() => import('./pages/wallet/list'));
const PageCoupons = React.lazy(() => import('./pages/coupons/list'));
const PageContact = React.lazy(() => import('./pages/contact'));
const PageDownloads = React.lazy(() => import('./pages/downloads'));
const PageFinancial = React.lazy(() => import('./pages/financial'));
const PagePriceTable = React.lazy(() => import('./pages/priceTable'));

const PageGridNew = React.lazy(() => import('./pages/grade/catalog'));
const PagePairNew = React.lazy(() => import('./pages/parapar/catalog'));
const PageOthersNew = React.lazy(() => import('./pages/outros-produtos/catalog'));
const PageSurfaceNew = React.lazy(() => import('./pages/surfacado/catalog'));
const PageDashboard = React.lazy(() => import('./pages/dashboard'));

const defaultProtectedRouteProps: Omit<ProtectedRouteProps, 'render'> = {};

const App = () => {
  const location = useLocation();

  const protectedRoutes = [
    {
      route: '/:rootPath/surfacado/empenho/:bloco',
      Component: FormSurfacado,
    },
    {
      route: '/:rootPath/surfacado/:metodo/:bloco/:os',
      Component: FormSurfacedEdit,
    },
    {
      route: '/:rootPath/parapar/empenho/:bloco',
      Component: FormParapar,
    },
    {
      route: '/:rootPath/parapar/edicao/:bloco/:os',
      Component: PageParaparEdit,
    },
    {
      route: '/:rootPath/parapar2/empenho/:bloco',
      Component: FormParapar,
    },
    {
      route: '/:rootPath/parapar2/edicao/:bloco/:os',
      Component: PageParaparEdit,
    },
    {
      route: '/:rootPath/surfacado',
      Component: PageSurfaceNew,
    },
    {
      route: '/:rootPath/dashboard',
      Component: PageDashboard,
    },
    {
      route: '/:rootPath/parapar',
      Component: PagePairNew,
    },
    {
      route: '/:rootPath/comprarcanetinha',
      Component: PageOthersNew,
    },
    {
      route: '/:rootPath/grade',
      Component: PageGridNew,
    },

    {
      route: '/:rootPath/meuspedidos',
      Component: PageMyOrders,
    },
    {
      route: '/:rootPath/carrinho',
      Component: PageCart,
    },
    {
      route: '/:rootPath/parapar2',
      Component: PageParapar,
    },
    {
      route: '/:rootPath/grade/empenho/:bloco',
      Component: FormGrade,
    },
    {
      route: '/:rootPath/lista/empenho/:bloco',
      Component: FormGradeList,
    },
    {
      route: '/:rootPath/lista/edicao/:bloco',
      Component: FormGradeList,
    },
    {
      route: '/:rootPath/comprarcanetinha/empenho/:bloco',
      Component: FormOthers,
    },
    {
      route: '/:rootPath/grade/edicao/:bloco',
      Component: FormGrade,
    },
    {
      route: '/:rootPath/grade/edicao/:bloco/:cartId',
      Component: FormGrade,
    },
    {
      route: '/:rootPath/lista/edicao/:bloco/:cartId',
      Component: FormGradeList,
    },
    {
      route: '/:rootPath/grade2/empenho/:bloco',
      Component: FormGrade,
    },
    {
      route: '/:rootPath/grade2/edicao/:bloco',
      Component: FormGrade,
    },
    {
      route: '/:rootPath/grade',
      Component: PageGrade,
    },
    {
      route: '/:rootPath/new-surface',
      Component: PageSurfaceNew,
    },
    {
      route: '/:rootPath/new-pair',
      Component: PagePairNew,
    },
    {
      route: '/:rootPath/checkout/:type',
      Component: PageCheckout,
    },
    {
      route: '/:rootPath/checkout-unified/:cartId',
      Component: PageCheckoutUnified,
    },
    {
      route: '/:rootPath/grade2',
      Component: PageGrade,
    },
    {
      route: '/:rootPath/enderecos',
      Component: PageAddress,
    },
    {
      route: '/:rootPath/usuarios',
      Component: PageUserManagement,
    },
    {
      route: '/:rootPath/cartoes',
      Component: PageWallet,
    },
    {
      route: '/:rootPath/cupons',
      Component: PageCoupons,
    },
    {
      route: '/:rootPath/duvidasecontato',
      Component: PageContact,
    },
    {
      route: '/:rootPath/downloads',
      Component: PageDownloads,
    },
    {
      route: '/:rootPath/financeiro',
      Component: PageFinancial,
    },
    {
      route: '/:rootPath/tabela-de-precos',
      Component: PagePriceTable,
    },
  ];
  return (
    <>
      <Routes location={location}>
        {protectedRoutes.map(({ route, Component }) => {
          return (
            <Route
              key={route}
              path={route}
              element={
                <PrivateRoute
                  {...defaultProtectedRouteProps}
                  render={
                    <Suspense fallback={<Loading />}>
                      <Component />
                    </Suspense>
                  }
                />
              }
            />
          );
        })}
        <Route
          path="/:rootPath?"
          element={
            <Suspense fallback={<Loading />}>
              <HomeNew />
            </Suspense>
          }
        />
        <Route
          path="/"
          element={
            <Suspense fallback={<Loading />}>
              <HomeNew />
            </Suspense>
          }
        />
        <Route
          path="/:rootPath/home-old"
          element={
            <Suspense fallback={<Loading />}>
              <Home />
            </Suspense>
          }
        />
        <Route
          path="/home-old"
          element={
            <Suspense fallback={<Loading />}>
              <Home />
            </Suspense>
          }
        />
        <Route
          path="/:rootPath/recoverPassword/:token/:userId"
          element={
            <Suspense fallback={<Loading />}>
              <RecoveryPassword />
            </Suspense>
          }
        />
        <Route
          path="/recoverPassword/:token/:userId"
          element={
            <Suspense fallback={<Loading />}>
              <RecoveryPassword />
            </Suspense>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default App;
